'use client';

import * as React from 'react';
import Link from 'next/link';
import { pathPrefixAtom } from 'app/blog/[domain]/_components/blog-state';
import { showMoreFromAtom } from 'app/blog/[domain]/_components/design-state';
import type { PostCardFields } from 'app/blog/[domain]/(standalone)/_server/types';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { PostCard } from '../../../../(home)/post-card';

export interface MorePostsProps {
  posts: PostCardFields[];
}

export function MorePosts({ posts }: MorePostsProps): JSX.Element {
  const t = useTranslations('Blog.Post.More');
  const showMoreFrom = useAtomValue(showMoreFromAtom);
  const urlPrefix = useAtomValue(pathPrefixAtom);
  if (!showMoreFrom) {
    return <></>;
  }
  return (
    <section className="more-posts">
      <p className="more-posts-kicker">{t('Latest')}</p>
      <h3 className="more-posts-title">{t('MoreFrom')}</h3>
      <ul className="more-posts-list">
        {posts.map((p) => (
          <PostCard key={p.id} post={p} />
        ))}
      </ul>
      <Link className="more-posts-link" href={`${urlPrefix}/#tag-tabs`}>
        {t('ViewAll')}
      </Link>
    </section>
  );
}
